module.exports = __webpack_public_path__ + "static/media/10UNOHRLLS9.e2657792.jpg";